import { UserTaggingQuestion, SelectQuestion } from './types';
import { useRef } from 'react';

export function makeUpdater<T>(mutate: (copy: T) => void) {
  const updater: (prev: T) => T = (prev) => {
    const copy = structuredClone(prev);
    mutate(copy);
    return copy;
  };
  return updater;
}

export function getIcon(userTagText: string) {
  switch (userTagText) {
    // User Role Icons
    case 'undergrad':
      return 'survey/file-document-outline.png';
    case 'graduate':
      return 'survey/school-outline.png';
    case 'faculty':
      return 'survey/book-open-variant.png';
    case 'profession':
      return 'survey/briefcase-outline.png';
    case 'retiree':
      return 'survey/account-box-outline.png';
    // User Authorship Icons
    case 'notPublished':
      return 'survey/note-off-outline.png';
    case 'academic':
      return 'survey/file-document-outline.png';
    case 'gradStudent':
      return 'survey/school-outline.png';
    case 'otherPublications':
      return 'survey/book-open-variant.png';
    // User Topic Icons
    case 'History':
      return 'survey/topics/history.svg';
    case 'Earth Sciences':
      return 'survey/topics/earthscience.svg';
    case 'Economics':
      return 'survey/topics/economics.svg';
    case 'Health Sciences':
      return 'survey/topics/healthscience.svg';
    case 'Philosophy':
      return 'survey/topics/philosophy.svg';
    case 'Physics':
      return 'survey/topics/physics.svg';
    case 'Psychology':
      return 'survey/topics/psychology.svg';
    case 'Engineering':
      return 'survey/topics/engineering.svg';
    case 'Anthropology':
      return 'survey/topics/anthropology.svg';
    case 'Chemistry':
      return 'survey/topics/chemistry.svg';
    case 'Literature':
      return 'survey/topics/literature.svg';
    case 'Biology':
      return 'survey/topics/biology.svg';
    case 'Computer Science':
      return 'survey/topics/computerscience.svg';
    case 'Law':
      return 'survey/topics/law.svg';
    case 'Mathematics':
      return 'survey/topics/mathematics.svg';
    case 'Theology':
      return 'survey/topics/theology.svg';
    // Icons for all userTagTypes
    case 'otherNoText':
      return 'survey/other.png';
    default:
      return 'survey/other.png';
  }
}

export const checkbox = (selected: boolean) => {
  return (
    <input
      type="checkbox"
      checked={selected}
      onChange={() => {}}
      style={{
        transform: 'scale(1.3)',
        boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.15)',
        backgroundColor: 'transparent',
      }}
    />
  );
};

export const radio = (selected: boolean) => {
  return (
    <input
      type="radio"
      checked={selected}
      onChange={() => {}}
      style={{
        transform: 'scale(1.3)',
        backgroundColor: 'transparent',
      }}
    />
  );
};

export const hasCustomAnswer = (question: SelectQuestion) => {
  return question.userTags.some((tag) => tag.userTagText === 'other');
};

export const useElapsedTime = (questions: UserTaggingQuestion[]) => {
  // FIXME: Use an array ref instead of array of refs
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const questionLoadTimes = questions.map(() => useRef<number>(-1));

  const questionElapsedTime = (questionIndex: number) => {
    const loadTime = questionLoadTimes[questionIndex].current;
    const elapsedTime = loadTime > 0 ? (Date.now() - loadTime) / 1000 : 0;
    return elapsedTime;
  };

  const getSetQuestionLoadTime = (questionIndex: number) => {
    return function setQuestionLoadTime() {
      if (questionLoadTimes[questionIndex].current < 0) {
        questionLoadTimes[questionIndex].current = Date.now();
      }
    };
  };

  return {
    questionElapsedTime: questionElapsedTime,
    getSetQuestionLoadTime: getSetQuestionLoadTime,
  };
};
